export var PartnerType;
(function (PartnerType) {
    PartnerType[PartnerType["Undefined"] = 0] = "Undefined";
    PartnerType[PartnerType["Municipality"] = 1] = "Municipality";
    PartnerType[PartnerType["Organisation"] = 2] = "Organisation";
    PartnerType[PartnerType["Congregation"] = 3] = "Congregation";
    PartnerType[PartnerType["Region"] = 5] = "Region";
    PartnerType[PartnerType["HealthCareDistrict"] = 6] = "HealthCareDistrict";
    PartnerType[PartnerType["Other"] = 7] = "Other";
    PartnerType[PartnerType["WellbeingServiceCounty"] = 8] = "WellbeingServiceCounty";
})(PartnerType || (PartnerType = {}));
